import React from 'react';
import { useHistory } from 'react-router-dom';
import { FiLogIn } from 'react-icons/fi';

import logo from '../../assets/logo-gigage-white.png';
import './home.css';

export default function Home() {
  const history = useHistory();

  function handleInit(e) {
    e.preventDefault();
    history.push('/options');
  }

  return (
    <div className="home-container">
      <section className="form">
        <img src={logo} alt="logo da gigage solutions" />
        <form onSubmit={handleInit}>
          <button className="button-home" type="submit">
            Iniciar Suporte
            <FiLogIn size={25} className="icon" />
          </button>
        </form>
      </section>
    </div>
  );
}
